<template>
	<div class="p-grid crud-demo">
		<div class="p-col-12">
			<div class="card">
				<Toolbar class="p-mb-4">
					<template v-slot:left>
						<Button label="添加" icon="pi pi-plus" class="p-button-success p-mr-2" @click="onAddClick" />
					</template>

					<template v-slot:right>
						<span class="p-input-icon-left">
							<i class="pi pi-search" />
							<InputText v-on:keyup.enter="basicSearch" v-model="searchKeyword" placeholder="检索" />
							<SplitButton label="检索" style="margin-left: .75em" @click="basicSearch" :model="items"></SplitButton>
						</span>
					</template>
				</Toolbar>

				<DataTable :value="users" dataKey="_id" :paginator="true" :rows="25" :rowHover="true" showGridlines 
							v-model:first="currentPageFirstIndex" 
							paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown" :rowsPerPageOptions="[5,10,25,50]"
							currentPageReportTemplate="Showing {first} to {last} of {totalRecords} users" responsiveLayout="stack">
					<template #header>
						<div style="text-align: center">
							<h4 class="p-m-0">用户信息</h4>
						</div>
					</template>

					<Column header="序号" headerStyle="width: 6em; text-align: left">
						<template #body="slotProps">
							<span style="color: RGB(33,150,243)">{{currentPageFirstIndex + slotProps.index + 1}}</span>
						</template>
					</Column>
					<Column field="name" header="姓名">
						<template #body="slotProps">
							{{slotProps.data.name}}
						</template>
					</Column>
					<Column field="email" header="邮箱">
						<template #body="slotProps">
							{{slotProps.data.email}}
						</template>
					</Column>
					<Column field="roles" header="权限">
						<template #body="slotProps">
							{{displayRoleNames(slotProps.data.roles)}}
						</template>
					</Column>
					<Column header="操作">
						<template #body="slotProps">
							<Button icon="pi pi-pencil" v-tooltip.top="'编辑'" class="p-button-rounded p-button-success p-mr-2" @click="onEditClick(slotProps.data)" />
							<Button icon="pi pi-trash" v-tooltip.top="'删除'" class="p-button-rounded p-button-warning" @click="onDeleteClick(slotProps.data)" />
						</template>
					</Column>
				</DataTable>

				<Dialog v-model:visible="userDialog" :header="crudOperation==='create'?'新建用户':crudOperation==='update'?'编辑用户':''" :modal="true" class="p-fluid">
					<div class="p-field">
						<label for="name">姓名</label>
						<InputText id="name" v-model.trim="user.name" required="true" autofocus />
					</div>
					<div class="p-field">
						<label for="email">邮箱</label>
						<InputText id="email" v-model.trim="user.email" required="true" autofocus />
					</div>
					<div class="p-field">
						<h6>角色</h6>
						<div v-for="role of roleOptions" :key="role.value" class="p-field-checkbox">
							<Checkbox :id="role.value" name="category" :value="role.value" v-model="user.roles" />
							<label :for="role.value">{{role.name}}</label>
						</div>
					</div>

					<template #footer>
						<div v-if="crudOperation==='create'">
							<Button label="取消" icon="pi pi-times" class="p-button-text" @click="hideDialog"/>
							<Button label="创建" icon="pi pi-check" class="p-button-primary" @click="createUser" />
						</div>
						<div v-if="crudOperation==='update'">
							<Button label="取消" icon="pi pi-times" class="p-button-text" @click="hideDialog"/>
							<Button label="编辑" icon="pi pi-check" class="p-button-primary" @click="editUser" />
						</div>
					</template>
				</Dialog>

				<Dialog v-model:visible="deleteUserDialog" :style="{width: '450px'}" header="消息确认" :modal="true">
					<div>
						<i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2em; color: orange; vertical-align: middle;" />
						<span style="color: orange">确定要删除如下用户吗?</span>
						<div style="text-indent: 3em;">姓名：{{ user.name }}</div>
						<div style="text-indent: 3em;">邮箱：{{ user.email }}</div>
					</div>
					<template #footer>
						<Button label="取消" icon="pi pi-times" class="p-button-text" @click="deleteUserDialog = false"/>
						<Button label="确定" icon="pi pi-check" class="p-button-primary" @click="deleteUser" />
					</template>
				</Dialog>

				<Dialog header="高级检索" v-model:visible="searchDialogDisplay" :style="{width: '60vw'}" :modal="true">
					<div class="p-grid">
						<div class="p-col-12">
							<label>姓名：</label><InputText class="user-info-input" type="text" v-model="filters.name"/>
						</div>
						<div class="p-col-12">
							<label>邮箱：</label><InputText class="user-info-input" type="text" v-model="filters.email"/>
						</div>
						<div class="p-col-12">
							<label>权限：</label><Dropdown class="user-info-dropdown" style="vertical-align: middle;" v-model="filters.role" :options="roleOptions" optionLabel="name" optionValue="value" :showClear="true"></Dropdown>
						</div>
					</div>
										
					<template #footer>
						<Button label="重置" icon="pi pi-refresh" class="p-button-success" style="float: left" @click="resetSearch" />
						<Button label="取消" icon="pi pi-times" class="p-button-text" @click="searchDialogDisplay=false" />
						<Button label="检索" icon="pi pi-search" @click="advancedSearch" />
					</template>
				</Dialog>

			</div>
		</div>
	</div>

</template>

<script>
import UserService from '../service/UserService';

export default {
	data() {
		return {
			crudOperation: '',    // 'create', 'read', 'update' or 'delete'
			users: null,
			userDialog: false,
			deleteUserDialog: false,
			searchDialogDisplay: false,
			user: {},
			roleOptions: [],
			filters: {},
			items: [
				{
					label: '高级检索',
					icon: 'pi pi-external-link',
					command: () => {
						this.searchDialogDisplay = true;
					}
				},
				{
					label: '重置检索',
					icon: 'pi pi-refresh',
					command: () => {
						this.resetSearch();
					}
				}
			],

			currentPageFirstIndex: 0,
		}
	},
	userService: null,
	created() {
		this.userService = new UserService();
	},
	mounted() {
		// Permission guard
		if(!this.isAdmin) {
			this.$router.push({path: '/access'});
			return;
		}

		this.userService.findUsers().then(data => this.users = data);
		this.roleOptions = this.userService.getRoleOptions();
	},
	methods: {
		displayRoleNames(value) {
			return this.userService.displayRoleNames(value);
		},
		onAddClick() {
			this.crudOperation = "create";
			this.user = {};
			this.userDialog = true;
		},
		onEditClick(user) {
			this.crudOperation = "update";
			this.user = {};
			this.user._id = user._id;
			this.user.name = user.name;
			this.user.email = user.email;
			this.user.roles = user.roles;
			this.userDialog = true;
		},
		onDeleteClick(user) {
			this.user = user;
			this.deleteUserDialog = true;
		},
		hideDialog() {
			this.userDialog = false;
		},
		createUser() {
			this.userService.addUser(this.user).then((user) => {
				this.userDialog = false;
				this.userService.findUsers()
                    .then(users => { 
						this.users = users;
						// loader.hide();
						this.$toast.add({severity: 'info', summary: '用户创建成功', detail: `姓名: ${user.name}\n邮箱: ${user.email}`, life: 5000});
					}).catch(error => {
						// loader.hide();
						if(error.response) {
							this.$toast.add({ severity: 'error', summary: '用户信息加载失败', detail: error.response.data.message });
						} else {
							this.$toast.add({ severity: 'error', summary: '用户信息加载失败', detail: error.message });
						}
					})
				
			}).catch(error => {
				// loader.hide();
				if(error.response) {
					this.$toast.add({ severity: 'error', summary: '操作失败', detail: error.response.data.message });
				} else {
                    this.$toast.add({ severity: 'error', summary: '操作失败', detail: error.message });
				}
			})
		},
		editUser() {
			this.userService.updateUser(this.user._id, this.user).then((user) => {
				this.userDialog = false;
				this.userService.findUsers()
                    .then(users => { 
						this.users = users;
						// loader.hide();
						this.$toast.add({severity: 'info', summary: '用户修改成功', detail: `姓名: ${user.name}\n邮箱: ${user.email}`, life: 5000});
					}).catch(error => {
						// loader.hide();
						if(error.response) {
							this.$toast.add({ severity: 'error', summary: '用户信息加载失败', detail: error.response.data.message });
						} else {
							this.$toast.add({ severity: 'error', summary: '用户信息加载失败', detail: error.message });
						}
					})
				
			}).catch(error => {
				// loader.hide();
				if(error.response) {
					this.$toast.add({ severity: 'error', summary: '操作失败', detail: error.response.data.message });
				} else {
                    this.$toast.add({ severity: 'error', summary: '操作失败', detail: error.message });
				}
			})
		},
		deleteUser() {
			// let loader = this.$loading.show();
			this.userService.deleteUser(this.user._id)
			.then((user) => {
				this.deleteUserDialog = false;
				this.userService.findUsers()
                    .then(users => { 
						this.users = users; 
						// loader.hide();
						this.$toast.add({severity: 'info', summary: '用户删除成功', detail: `姓名: ${user.name}\n邮箱: ${user.email}`, life: 5000});
                    }).catch(error => {
						// loader.hide();
						if(error.response) {
							this.$toast.add({ severity: 'error', summary: '用户信息加载失败', detail: error.response.data.message });
						} else {
							this.$toast.add({ severity: 'error', summary: '用户信息加载失败', detail: error.message });
						}
					})
				
			}).catch(error => {
				// loader.hide();
				if(error.response) {
					this.$toast.add({ severity: 'error', summary: '操作失败', detail: error.response.data.message });
				} else {
                    this.$toast.add({ severity: 'error', summary: '操作失败', detail: error.message });
				}
			});
		},
		confirmDeleteUser(user) {
			this.user = user;
			this.deleteUserDialog = true;
		},
		basicSearch() {
			// let loader = this.$loading.show();
			if(this.searchKeyword != null && this.searchKeyword.length > 0) {
                this.filters.search = this.searchKeyword;
			} else {
				this.filters.search = null;
			}
			this.userService.findUsers(this.filters)
			.then(users => { 
				this.users = users; 
				// loader.hide();
				// this.$toast.add({severity: 'info', summary: '检索已完成', life: 3000});
			}).catch(error => {
				// loader.hide();
				if(error.response) {
					this.$toast.add({ severity: 'error', summary: '操作失败', detail: error.response.data.message });
				} else {
					this.$toast.add({ severity: 'error', summary: '操作失败', detail: error.message });
				}
			});
		},
		advancedSearch() {
			this.userService.findUsers(this.filters)
                .then(users => { 
					this.users = users; 
					this.searchDialogDisplay = false;
				}).catch(error => {
					this.$toast.add({ severity: 'error', summary: '操作失败', detail: error.message });
				});
		},

		resetSearch() {
			this.filters = {};
			this.searchKeyword = null;
			this.userService.findUsers(this.filters)
                .then(users => { 
					this.users = users; 
					this.searchDialogDisplay = false;
					// this.$toast.add({severity: 'info', summary: '检索已重置', life: 3000});
				}).catch(error => {
					this.$toast.add({ severity: 'error', summary: '操作失败', detail: error.message });
				});
		},
	},
	computed: {
		loggedIn() {
            return this.$store.state.authentication.status.loggedIn;
        },
        userInfo() {
            return this.$store.state.authentication.user;
		},
		canApprove() {
            return this.isPreapprover || this.isApprover;
        },
        isPreapprover() {
			return this.$store.state.authentication.permissions.preapprover === true;
        },
        isApprover() {
			return this.$store.state.authentication.permissions.approver === true;
		},
		isAdmin() {
			return this.$store.state.authentication.permissions.admin === true;
		},
    }
}
</script>

<style scoped lang="scss">
	.table-header {
		display: flex;
		justify-content: space-between;
	}

	.confirmation-content {
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.user-info-input {
		width: 16em; 
	}

	.user-info-dropdown {
		width: 16em; 
		vertical-align: middle;
	}

	::v-deep(.p-toolbar) {
		flex-wrap: wrap;
		.p-button {
			margin-bottom: .25rem;
		}
	}
</style>
